export default {
      id: "microphone-usage",
      viewBox: "0 0 12 18",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#microphone",
      toString: function () {
        return this.url;
      }
    }